import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { usePOS } from '../../../contexts/POSContext';
import { formattedCurrency } from '../../../utils/utils';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';

const POSDiscountModal = ({ open, onClose }) => {
  const {
    totals,
    manualDiscount,
    setManualDiscount,
    manualDiscountType,
    setManualDiscountType,
    isDarkMode,
  } = usePOS();

  const [discountVal, setDiscountVal] = useState(manualDiscount || 0);
  const [type, setType] = useState(manualDiscountType || 'money');
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setDiscountVal(manualDiscount || 0);
      setType(manualDiscountType || 'money');
      setTimeout(() => {
        if (inputRef.current) inputRef.current.focus();
      }, 100);
    }
  }, [open, manualDiscount, manualDiscountType]);

  const handleApply = () => {
    setManualDiscount(parseFloat(discountVal) || 0);
    setManualDiscountType(type);
    onClose();
  };

  const handleClear = () => {
    setManualDiscount(0);
    setManualDiscountType('money');
    onClose();
  };

  const calculatedDiscount = type === 'percent'
    ? (totals.subtotal * (parseFloat(discountVal) || 0)) / 100
    : (parseFloat(discountVal) || 0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: isDarkMode ? 'pos-dark-paper' : '' }}
    >
      <UIDialogTitle onClose={onClose}>
        Desconto na Venda [F9]
      </UIDialogTitle>

      <DialogContent dividers style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            fullWidth
            variant={type === 'money' ? 'contained' : 'outlined'}
            onClick={() => setType('money')}
            style={{
              backgroundColor: type === 'money' ? '#17497F' : 'transparent',
              color: type === 'money' ? '#ffffff' : '#17497F',
              borderColor: '#17497F',
              fontWeight: 600,
              textTransform: 'none',
            }}
          >
            Em Dinheiro (R$)
          </Button>
          <Button
            fullWidth
            variant={type === 'percent' ? 'contained' : 'outlined'}
            onClick={() => setType('percent')}
            style={{
              backgroundColor: type === 'percent' ? '#17497F' : 'transparent',
              color: type === 'percent' ? '#ffffff' : '#17497F',
              borderColor: '#17497F',
              fontWeight: 600,
              textTransform: 'none',
            }}
          >
            Em Porcentagem (%)
          </Button>
        </div>

        <TextField
          inputRef={inputRef}
          label={type === 'money' ? 'Valor do Desconto (R$)' : 'Porcentagem do Desconto (%)'}
          type="number"
          variant="outlined"
          fullWidth
          value={discountVal}
          onChange={(e) => setDiscountVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleApply();
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <span style={{ fontWeight: 700 }}>
                  {type === 'money' ? 'R$' : '%'}
                </span>
              </InputAdornment>
            ),
          }}
        />

        <div style={{ background: '#f5f5f5', padding: 12, borderRadius: 4, fontSize: '0.9rem', border: '1px solid #e0e0e0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: '#616161' }}>
            <span>Subtotal da Venda:</span>
            <span>{formattedCurrency(totals.subtotal)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: '#2e7d32', marginTop: 4, fontWeight: 700 }}>
            <span>Desconto a Aplicar:</span>
            <span>- {formattedCurrency(calculatedDiscount)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: '#212121', marginTop: 4, fontWeight: 800, borderTop: '1px solid #e0e0e0', paddingTop: 4 }}>
            <span>Novo Total:</span>
            <span>{formattedCurrency(Math.max(0, totals.subtotal - calculatedDiscount))}</span>
          </div>
        </div>
      </DialogContent>

      <DialogActions style={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={handleClear} style={{ color: '#d32f2f', textTransform: 'none' }}>
          Remover Desconto
        </Button>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={onClose} color="default">
            Cancelar [Esc]
          </Button>
          <Button
            onClick={handleApply}
            variant="contained"
            color="primary"
            style={{ backgroundColor: '#185421', textTransform: 'none', fontWeight: 600 }}
          >
            Confirmar [Enter]
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default POSDiscountModal;
